import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styles from './RegisterSupplier.module.scss';
import {
    loadProvinces,
    selectProvincesDropdown,
    loadCities,
    selectCitiesDropdown,
    loadWaySells,
    selectWaySells,
    loadPriceVariants,
    selectPriceVariants,
    loadCategories,
    selectCategories,
    addSupplier
} from './registerSupplierSlice';
import { Form, Field, useField, FormSpy } from 'react-final-form'
import { ReactSelectAdapter } from '../../components/FinalFormExtend/FinalFormExtend';
import { LoadingContext } from '../../providers/LoadingContext';
import { NotificationContext } from '../../providers/NotificationContext';

const Error = ({ name }) => {
    const {
        meta: { touched, error }
    } = useField(name, { subscription: { touched: true, error: true } });
    return touched && error ? <span>{error}</span> : null;
};

const RegisterSupplierUI = (props) => {
    const provinces = useSelector(selectProvincesDropdown);
    const cities = useSelector(selectCitiesDropdown);
    const waySells = useSelector(selectWaySells);
    const priceVariants = useSelector(selectPriceVariants);
    const categories = useSelector(selectCategories);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProvince, setSelectedProvince] = useState({ label: "Select...", value: 'null' });
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [whatsappNumber, setWhatsappNumber] = useState(null);
    const [website, setWebsite] = useState(null);
    const [facebook, setFacebook] = useState(null);
    const [instagram, setInstagram] = useState(null);
    const [tokopedia, setTokopedia] = useState(null);
    const [shopee, setShopee] = useState(null);
    const [description, setDescription] = useState(null);
    const [isDropship, setIsDropship] = useState(null);
    const [isCatalog, setIsCatalog] = useState(null);
    const [supplierType, setSupplierType] = useState(null);
    const [category, setCategory] = useState(null);
    const [priceVariant, setPriceVariant] = useState(null);
    const [waySell, setWaySell] = useState(null);
    let errorMessage = "Data ini harus diisi";

    useEffect(() => {
        if (provinces.length === 0) {
            dispatch(loadProvinces()).then((data) => {
                setIsLoading(false);
            });
        }

        dispatch(loadPriceVariants());
        dispatch(loadWaySells());
        dispatch(loadCategories());
    }, [dispatch]);

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    const onSubmit = async (
        values,
        setIsLoadingFunc,
        showNotificationMessageFunc,
    ) => {
        await sleep(300);
        setIsLoadingFunc(true);

        values.city = values.city.value;

        dispatch(addSupplier(values, setIsLoadingFunc, showNotificationMessageFunc));
    };


    return (
        <div>
            <div className={styles.Banner__wrapper}>
                <img className="undragable w-100" alt="Daftar Reseller" src="./assets/join-reseller-banner.jpg" />
                <h1 className={styles.Banner__title}>Bergabung Menjadi Supplier</h1>
            </div>
            <div>
                <Form
                    onSubmit={(values) => onSubmit(
                        values,
                        props.setIsLoading,
                        props.showNotificationMessage
                    )}
                    validate={values => {
                        const errors = {}
                        if (!values.name) {
                            errors.name = errorMessage;
                        }
                        if (!values.email) {
                            errors.email = errorMessage;
                        }
                        if (!values.whatsapp_number) {
                            errors.whatsapp_number = errorMessage;
                        }
                        if (!values.website) {
                            errors.website = errorMessage;
                        }
                        if (!values.facebook) {
                            errors.facebook = errorMessage;
                        }
                        if (!values.instagram) {
                            errors.instagram = errorMessage;
                        }
                        if (!values.tokopedia) {
                            errors.tokopedia = errorMessage;
                        }
                        if (!values.shopee) {
                            errors.shopee = errorMessage;
                        }
                        if (!values.description) {
                            errors.description = errorMessage;
                        }
                        if (!values.is_dropship) {
                            errors.is_dropship = errorMessage;
                        }
                        if (!values.is_catalog) {
                            errors.is_catalog = errorMessage;
                        }
                        if (!values.city) {
                            errors.city = errorMessage;
                        }
                        if (!values.supplier_type) {
                            errors.supplier_type = errorMessage;
                        }
                        if (!values.category) {
                            errors.category = errorMessage;
                        }
                        if (!values.price_variants) {
                            errors.price_variants = errorMessage;
                        }
                        if (!values.way_sells) {
                            errors.way_sells = errorMessage;
                        }
                        return errors
                    }}
                    initialValues={{
                        name: name,
                        email: email,
                        whatsapp_number: whatsappNumber,
                        website: website,
                        facebook: facebook,
                        instagram: instagram,
                        tokopedia: tokopedia,
                        shopee: shopee,
                        description: description,
                        is_dropship: isDropship,
                        is_catalog: isCatalog,
                        supplier_type: supplierType,
                        category: category,
                        price_variants: priceVariant,
                        way_sells: waySell,
                        province: selectedProvince,
                    }}
                    render={({ handleSubmit, form, submitting, pristine, values }) => (
                        <div className="container pt-7 pb-7">
                            <div className="col-xl-12">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-xl-6">
                                            <div className="form-group">
                                                <label>Nama</label>
                                                <Field
                                                    name="name"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="name" />
                                            </div>
                                            <div className="form-group">
                                                <label>Email</label>
                                                <Field
                                                    name="email"
                                                    component="input"
                                                    type="email"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="email" />
                                            </div>
                                            <div className="form-group">
                                                <label>Whatsapp / Nomor Handphone</label>
                                                <Field
                                                    name="whatsapp_number"
                                                    component="input"
                                                    type="number"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="whatsapp_number" />
                                            </div>
                                            <div className="form-group">
                                                <label>Website Usaha</label>
                                                <Field
                                                    name="website"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="website" />
                                            </div>
                                            <div className="form-group">
                                                <label>Facebook</label>
                                                <Field
                                                    name="facebook"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="facebook" />
                                            </div>
                                            <div className="form-group">
                                                <label>Instagram</label>
                                                <Field
                                                    name="instagram"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="instagram" />
                                            </div>
                                            <div className="form-group">
                                                <label>Tokopedia</label>
                                                <Field
                                                    name="tokopedia"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="tokopedia" />
                                            </div>
                                            <div className="form-group">
                                                <label>Shopee</label>
                                                <Field
                                                    name="shopee"
                                                    component="input"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                />
                                                <Error name="shopee" />
                                            </div>
                                            <div className="form-group">
                                                <label>Provinsi</label>
                                                <Field name="province"
                                                    options={provinces}
                                                    component={ReactSelectAdapter}
                                                >
                                                </Field>
                                                <Error name="province" />
                                            </div>
                                            <div className="form-group">
                                                <label>Kota</label>
                                                <Field name="city"
                                                    options={cities}
                                                    component={ReactSelectAdapter}
                                                >
                                                </Field>
                                                <Error name="city" />
                                            </div>
                                        </div>
                                        <div className="col-xl-6">
                                            <div className="form-group">
                                                <label>Deskripsikan produk anda</label>
                                                <Field
                                                    name="description"
                                                    component="textarea"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control custom-height"
                                                />
                                                <Error name="description" />
                                            </div>
                                            <div className="form-group">
                                                <label>Apakah Anda produsen / penjual grosir?</label>
                                                <br />
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="supplier_type"
                                                            component="input"
                                                            type="radio"
                                                            value="M"
                                                            className="form-check-input"
                                                        />{' '}Produsen
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="supplier_type"
                                                            component="input"
                                                            type="radio"
                                                            value="D"
                                                        />{' '}Grosir
                                                    </label>
                                                </div>
                                                <Error name="supplier_type" />
                                            </div>
                                            <div className="form-group">
                                                <label>Apakah bersedia pengiriman dropship?</label>
                                                <br />
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="is_dropship"
                                                            component="input"
                                                            type="radio"
                                                            value="true"
                                                            className="form-check-input"
                                                        />{' '}Ya
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="is_dropship"
                                                            component="input"
                                                            type="radio"
                                                            value="false"
                                                        />{' '}Tidak
                                                    </label>
                                                </div>
                                                <Error name="is_dropship" />
                                            </div>
                                            <div className="form-group">
                                                <label>Apakah Anda memiliki katalog?</label>
                                                <br />
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="is_catalog"
                                                            component="input"
                                                            type="radio"
                                                            value="true"
                                                        />{' '}Ya
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <label className="form-check-label">
                                                        <Field
                                                            name="is_catalog"
                                                            component="input"
                                                            type="radio"
                                                            value="false"
                                                        />{' '}Tidak
                                                    </label>
                                                </div>
                                                <Error name="is_catalog" />
                                            </div>
                                            <div className="form-group">
                                                <label className="form-check-label">Kategori Produk</label>
                                                {categories.map((category) => (
                                                    <div className="form-check" key={category.id}>
                                                        <Field
                                                            name="category"
                                                            component="input"
                                                            type="checkbox"
                                                            value={category.id}
                                                            className="form-check-input"
                                                            id={"category" + category.id}
                                                        />
                                                        <label htmlFor={"category" + category.id}
                                                            className="form-check-label">{' '}{category.name}</label>
                                                    </div>
                                                ))}
                                                <Error name="category" />
                                            </div>
                                            <div className="form-group">
                                                <label>Range Harga Produk</label> <br />
                                                {priceVariants.map((priceVariant) => (
                                                    <div className="form-check" key={priceVariant.id}>
                                                        <Field
                                                            name="price_variants"
                                                            component="input"
                                                            type="checkbox"
                                                            value={priceVariant.id}
                                                            className="form-check-input"
                                                            id={"priceVariant" + priceVariant.id}
                                                        />
                                                        <label htmlFor={"priceVariant" + priceVariant.id}
                                                            className="form-check-label">{' '}{priceVariant.description}</label>
                                                    </div>
                                                ))}
                                                <Error name="price_variants" />
                                            </div>
                                            <div className="form-group">
                                                <label>Apa saluran distribusi yang Anda gunakan saat ini?</label> <br />
                                                {waySells.map((waySell, j) => (
                                                    <div className="form-check" key={waySell.id}>
                                                        <Field
                                                            name="way_sells"
                                                            component="input"
                                                            type="checkbox"
                                                            value={waySell.id}
                                                            className="form-check-input"
                                                            id={"waySells" + waySell.id}
                                                        />
                                                        <label htmlFor={"waySells" + waySell.id}
                                                            className="form-check-label">{' '}{waySell.description}</label>
                                                    </div>
                                                ))}
                                                <Error name="way_sells" />
                                            </div>
                                            <div className="form-group hidden">
                                                <label>Notes</label>
                                                <textarea className="form-control" name="notes" rows="3"></textarea>
                                            </div>
                                        </div>
                                        <div className="buttons-wrapper pt-3">
                                            <button type="submit" className="btn btn-primary btn-action" >Submit</button>&emsp;
                                            <button type="button" onClick={form.reset} className="btn btn-outline-secondary btn-action">Reset</button>
                                        </div>

                                        <FormSpy subscription={{ values: true }}>
                                            {({ values }) => {
                                                if (values.province != undefined &&
                                                    values.province.value != selectedProvince.value) {
                                                    const { label, value } = values.province;
                                                    if (value != 'null') dispatch(loadCities(value));
                                                    setName(values.name);
                                                    setEmail(values.email);
                                                    setWhatsappNumber(values.whatsapp_number);
                                                    setWebsite(values.website);
                                                    setFacebook(values.facebook);
                                                    setInstagram(values.instagram);
                                                    setTokopedia(values.tokopedia);
                                                    setShopee(values.shopee);
                                                    setDescription(values.description);
                                                    setIsDropship(values.is_dropship);
                                                    setIsCatalog(values.is_catalog);
                                                    setSupplierType(values.supplier_type);
                                                    setPriceVariant(values.price_variants);
                                                    setWaySell(values.way_sells);
                                                    setCategory(values.category);
                                                    setSelectedProvince({ label: label, value: value });
                                                }
                                                return <div></div>;
                                            }}
                                        </FormSpy>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}

export const RegisterSupplier = () => {
    return (
        <LoadingContext.Consumer>
            {({ setIsLoading }) => (
                <NotificationContext.Consumer>
                    {({ showNotificationMessage }) => (
                        <RegisterSupplierUI setIsLoading={setIsLoading}
                            showNotificationMessage={showNotificationMessage}
                        />
                    )}
                </NotificationContext.Consumer>
            )}
        </LoadingContext.Consumer>
    )
}